import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ProductCategories from '../components/ProductCategories';
import ProductSection from '../components/ProductSection';
import ProductInquiry from '../components/ProductInquiry';
import Testimonials from '../components/Testimonials';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import { 
  productCategories, 
  akiwaProProducts, 
  akiwaHomeProducts, 
  akiwaSecurityProducts,
  testimonials 
} from '../mock';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <ProductCategories categories={productCategories} />
      
      {/* AKIWA PRO Section */}
      <ProductSection
        title="AKIWA PRO"
        subtitle="Professional solutions designed to maximize your business impact and operational efficiency"
        products={akiwaProProducts}
        categoryId="pro"
        bgColor="bg-gray-50"
      />

      {/* AKIWA HOME Section */}
      <ProductSection
        title="AKIWA HOME"
        subtitle="Transform your living space with premium entertainment and comfort solutions"
        products={akiwaHomeProducts}
        categoryId="home"
        bgColor="bg-white"
      />

      {/* AKIWA SECURITY Section */}
      <ProductSection
        title="AKIWA SECURITY"
        subtitle="Advanced security systems for complete peace of mind"
        products={akiwaSecurityProducts}
        categoryId="security"
        bgColor="bg-gray-50"
      />

      <ProductInquiry />
      <Testimonials testimonials={testimonials} />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Home;
